import React from "react";
import SupportLayout from "./SupportLayout";
import SupportOfficerHomeContent from "../support-officer/components/SupportOfficerHomeContent";

const SupportHome = () => {
  return (
    <SupportLayout userRole="SM">
      <SupportOfficerHomeContent
        userRole="SM"
        useOwnLayout={false}
        showDateFilter={false}
      />
    </SupportLayout>
  );
};

export default SupportHome;
